<template>
  <div class="job-detail-page">
    <AppHeader :detail-mode="true" :force-color-logo="true" />
    <div class="main-content">
      <div class="container animate-scroll">
        <h1 class="job-title">{{ job.title }}</h1>
        <div class="job-date">{{ formatDate(job.createtime) }}</div>
        <div class="job-meta">招聘性质：{{ job.nature }}</div>
        <div class="job-section animate-scroll">
          <div class="section-title">岗位职责：</div>
          <div class="section-text" style="white-space: pre-line">{{ job.responsibility }}</div>
        </div>
        <div class="job-section animate-scroll">
          <div class="section-title">职位要求：</div>
          <div class="section-text" style="white-space: pre-line">{{ job.requirements }}</div>
        </div>
        <div class="job-section animate-scroll">
          <div class="section-title">薪资待遇：</div>
          <div class="section-text">{{ job.salary || '面议' }}</div>
        </div>
        <div class="job-section animate-scroll">
          <div class="section-title">工作地点：</div>
          <div class="section-text">{{ job.address }}</div>
        </div>
        <div class="job-section animate-scroll">
          <div class="section-title">投递方式：</div>
          <div class="section-text">{{ job.deliver }}</div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper">
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';
import { getJobInfo } from '@/api';

export default {
  name: 'JobDetailPage',
  components: {
    AppFooter,
    AppHeader
  },
  data() {
    return {
      job: {
        id: null,
        title: '',
        nature: '',
        responsibility: '',
        requirements: '',
        salary: '',
        address: '',
        deliver: '',
        createtime: ''
      }
    }
  },
  created() {
    this.fetchJobDetail();
  },
  mounted() {
    this.initScrollAnimations();
    this.$nextTick(() => {
      this.setAnimateVisible();
    });
  },
  methods: {
    async fetchJobDetail() {
      try {
        const id = this.$route.params.id;
        const res = await getJobInfo(id);
        if (res.data && res.code === 1) {
          this.job = res.data;
        }
      } catch (error) {
        console.error('获取职位详情失败:', error);
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    initScrollAnimations() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      const section = this.$el;
      if (section) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const animatedElements = entry.target.querySelectorAll('.animate-scroll');
              animatedElements.forEach(el => {
                el.classList.add('visible');
              });
            }
          });
        }, options);
        observer.observe(section);
      }
    },
    setAnimateVisible() {
      const animatedElements = this.$el.querySelectorAll('.animate-scroll');
      animatedElements.forEach((el, idx) => {
        setTimeout(() => {
          el.classList.add('visible');
        }, idx * 120);
      });
    }
  }
}
</script>

<style scoped>
.job-detail-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.footer-wrapper {
  flex-shrink: 0;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
}

.job-title {
  font-size: 36px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  margin-top: 0;
}

.job-date {
  font-size: 16px;
  color: #999;
  margin-bottom: 16px;
}

.job-meta {
  font-size: 18px;
  color: #666;
  margin-bottom: 32px;
  font-weight: bold;
}

.job-section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.section-list {
  padding-left: 24px;
  color: #333;
  font-size: 18px;
  line-height: 2;
  font-weight: bold;
}

.section-text {
  font-size: 18px;
  color: #333;
  line-height: 1.8;
  font-weight: bold;
}

.animate-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;
}

.animate-scroll.visible {
  opacity: 1;
  transform: translateY(0);
}
</style> 